module.exports = __webpack_public_path__ + "static/media/instagram-icon.9c933bb2.svg";